export default __webpack_public_path__ + "static/dx-01-3aa7b1850e0b4eb0b97f68d33948d3a0.svg";